import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { getFirebaseBackend } from "../../../helpers/firebase_helper"
import {
  postFakeProfile,
  postJwtProfile,
} from "../../../helpers/fakebackend_helper"

// Initialisation de la connexion Firebase
const fireBaseBackend = getFirebaseBackend()

// **AsyncThunk pour l'édition du profil**
export const editProfile = createAsyncThunk(
  "profile/editProfile", // nom de l'action
  async (user, { rejectWithValue }) => {
    try {
      let response
      if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
        response = await fireBaseBackend.editProfileAPI(user.username, user.idx)
      } else if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
        response = await postJwtProfile("/post-jwt-profile", {
          username: user.username,
          idx: user.idx,
        })
      } else if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
        response = await postFakeProfile({
          username: user.username,
          idx: user.idx,
        })
      }

      if (response) {
        return response
      }
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

// Création du Slice
const profileSlice = createSlice({
  name: "profile",
  initialState: {
    error: null,
    success: null,
  },
  reducers: {
    resetProfileFlag: (state) => {
      state.success = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(editProfile.pending, (state) => {
        state.success = null
        state.error = null
      })
      .addCase(editProfile.fulfilled, (state, action) => {
        state.success = action.payload
      })
      .addCase(editProfile.rejected, (state, action) => {
        state.error = action.payload
      })
  },
})

export const { resetProfileFlag } = profileSlice.actions

export default profileSlice.reducer
